import { ITimezone } from 'app/services/constants';
import { Validators } from 'utils/Validators';
import * as Yup from 'yup';

export type FormInputs = Partial<{
  given_name: string;
  family_name: string;
  email: string;
  zipcode: string;
  country: string;
  state: string;
  city: string;
  address: string;
  service_type: string;
  specialization_id?: number;
  language_id?: number;
  time_zone_id?: number;
  is_verified_phone_number: boolean;

  ssn: string;
  birth_date: string;
  occupation: string;

  tax_filing_status: string;
  spouse_attributes: Partial<{
    firstname: string;
    lastname: string;
    ssn: string;
    birth_date: string;
    occupation: string;
    phone_number: string;
    _destroy: boolean;
  }>;

  dependents_attributes: Partial<{
    relationship: string;
    firstname: string;
    lastname: string;
    ssn: string;
    birth_date: string;
  }>;
}>;
export const serviceTypeOptions = [
  { label: 'Individual', value: 'individual' },
  { label: 'Business', value: 'business' },
  //{ label: 'Both Individual & Business', value: 'both' },
  { label: 'Prospect', value: 'prospect' },
  { label: 'Trust', value: 'trust' },
  { label: 'Non-Profit', value: 'non_profit' },
];

export const validationSchema = (initialData: FormInputs) =>
  Yup.object().shape({
    given_name: Yup.string().trim().required('required'),
    family_name: Yup.string().trim().required('required'),
    phone_number: Yup.string().trim(),
    email: Yup.string().trim(),
    zipcode: Validators.zipCode.required('required'),
    time_zone_id: Yup.number().required('required'),
    language_id: Yup.number().required('required'),
    specialization_id: Yup.string().required('required'),
    state: Yup.string().required('required'),
    country: Yup.string().required('required'),
    city: Yup.string().required('required'),
    address: Yup.string().required('required'),
    service_type: Yup.string().required('required'),
    is_verified_phone_number: Yup.bool().oneOf(
      [true],
      'Please verify your phone number',
    ),
  });
